export default "https://assets-v2.scaler.com/packs/images/join-scaler.7a81ad.svg";